'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var TitleAndLink = require('../TitleAndLink/TitleAndLink.js');

var VerticalTitleAndLink = function (props) {
    var titleText = props.titleText, linkText = props.linkText, url = props.url, dataTestId = props["data-testid"];
    return (React__default.createElement(TitleAndLink, { "data-testid": dataTestId, titleText: titleText, url: url, linkText: linkText, direction: 'column' }));
};

module.exports = VerticalTitleAndLink;
